import packageJson from '../../package.json';
import { INTMIN } from 'isdlaccess/dist/isdl/api/taskmanData';
import { GetCurrentSession } from '../isdlData/sessionData';

export function formatShotData(dataType, data, ignoreAdjValue = false) {

    if(data === null)
        return null;

    if(data === undefined)
        return null;

    if(Number.isNaN(data))
        return null;

    if(data === 'NaN'){
        return null;
    }

    let returnValue = "";
    switch (dataType) {
        case "ShotApexFt":
        case "BallBackSpinRpm":
        case "BallSideSpinRpm":
        case "BallSpinRPM":
            returnValue = data.toFixed(0); // no decimal
            break;
        default: // The rest are 1 decimal place
            returnValue = data.toFixed(1);
            break;
        case "SmashFactor":
            returnValue = data.toFixed(2);
            break;
        case "OutInRatio":
            returnValue = data.toFixed(3);
            break;
        case "ImpactYawAngleDeg":
            returnValue = data.toFixed(1);
            break;
        case "AddressFace":
            returnValue = data.toFixed(1);
            break;
        case "Face":
            returnValue = data.toFixed(1);
            break;
        case "AdjImpHorizLocInch":
        case "AdjImpVertLocInch":
        case "ImpactHorizLocInch":
        case "ImpactVertLocInch":
            if(!ignoreAdjValue){
                returnValue = (data * 25.4).toFixed(1);
            }else{
                returnValue = data.toFixed(2);
            }
            break;
        //case "AdjImpHorizLocMM":
        //case "AdjImpVertLocMM":
        //case "ImpactHorizLocMM":
        //case "ImpactVertLocMM":
        //    returnValue = data .toFixed(1);
        //    break;//Not right
    }
    return returnValue;
};

function roundToDecimals(value, decimals = 2) {
    const factor = 10 ** decimals;
    return Math.round(value * factor) / factor;
}

function calculateGcQuadAdjustedImpact(measurements) {
    if (!measurements) {
        return {};
    }

    const mmToInch = 1 / 25.4;
    const faceAngle = Number(measurements.ImpactYawAngleDeg);
    const horizontalPath = Number(measurements.ImpactPathAngleDeg);
    const loft = Number(measurements.ImpactPitchAngleDeg);
    const verticalPath = Number(measurements.ImpactAttackAngleDeg);
    const horizontalImpact = Number(measurements.ImpactHorizLocInch); //when ImpactHorizLocMM ?
    const verticalImpact = Number(measurements.ImpactVertLocInch);

    const calculatedMeasurements = {};

    if (
        Number.isFinite(faceAngle) &&
        Number.isFinite(horizontalPath) &&
        Number.isFinite(horizontalImpact)
    ) {
        const horizontalOffset = (12.5 * Math.sin((faceAngle * Math.PI / 180) - (horizontalPath * Math.PI / 180))) * mmToInch;
        calculatedMeasurements.AdjImpHorizLocInch = roundToDecimals(horizontalOffset, 2) + horizontalImpact;
    }

    if (
        Number.isFinite(loft) &&
        Number.isFinite(verticalPath) &&
        Number.isFinite(verticalImpact)
    ) {
        const verticalOffset = (12.5 * Math.sin((loft * Math.PI / 180) - (verticalPath * Math.PI / 180))) * mmToInch;
        calculatedMeasurements.AdjImpVertLocInch = roundToDecimals(verticalOffset, 2) + verticalImpact;
    }

    return calculatedMeasurements;
}

function calculateResearchQuadDerivedMeasurements(measurements) {
    if (!measurements) {
        return {};
    }

    const preSpeed = Number(measurements.pre_BallSpeedMph);
    const postSpeed = Number(measurements.post_BallSpeedMph);

    if (!Number.isFinite(preSpeed) || preSpeed === 0 || !Number.isFinite(postSpeed)) {
        return {};
    }

    return {
        OutInRatio: postSpeed / preSpeed
    };
}

export function getAllMeasurementsForLMInfo(lmInfo) {
    const measurements = {
        ...(lmInfo?.Measurements || {}),
        ...(lmInfo?.CalculatedMeasurements || {})
    };
    const allMeasurements = {
        ...measurements,
        ...calculateGcQuadAdjustedImpact(measurements)
    };
    if (lmInfo?.LMType === 'GC_QUAD') {
        return {
            ...allMeasurements,
            ...calculateGcQuadAdjustedImpact(measurements),
            //ImpactHorizLocMM: allMeasurements.ImpactHorizLocInch != null ? allMeasurements.ImpactHorizLocInch * 25.4 : undefined,
            //ImpactVertLocMM: allMeasurements.ImpactVertLocInch != null ? allMeasurements.ImpactVertLocInch * 25.4 : undefined,
            //AdjImpHorizLocMM: allMeasurements.AdjImpHorizLocInch != null ? allMeasurements.AdjImpHorizLocInch * 25.4 : undefined,
            //AdjImpVertLocMM: allMeasurements.AdjImpVertLocInch != null ? allMeasurements.AdjImpVertLocInch * 25.4 : undefined
        };
    }

    if (lmInfo?.LMType === 'RESEARCH_QUAD') {
        return {
            ...measurements,
            ...calculateResearchQuadDerivedMeasurements(measurements)
        };
    }

    return measurements;
}

export function getImpactTargetHalfMm(targetinfo,robotFaceMap) {
    const testType = (robotFaceMap?.TestType || '').toUpperCase();

    if (testType.includes('INTERNAL')) {
        return 2;
    }

    if (testType.includes('CLAIMS') || testType.includes('CLAIM')) {
        return 1.5;
    }

    return 1.5;
}

export function getImpactMeasurementKeys(targetingo,robotFaceMap) {
    const testType = (robotFaceMap?.TestType || '').toUpperCase();

    if (testType.includes('INTERNAL')) {
        return {
            xKey: 'AdjImpHorizLocInch',
            yKey: 'AdjImpVertLocInch',
            isAdjusted: true
        };
    }

    return {
        xKey: 'ImpactHorizLocInch',
        yKey: 'ImpactVertLocInch',
        isAdjusted: false
    };
}


export function getHandicap(handicap) {
    if (handicap < 0 && handicap > -9998) {
        return Math.abs(Number(handicap)).toFixed(1);
    } else if (handicap > 0) {
        return "+" + Number(handicap).toFixed(1);
    } else if (handicap <= -9998 || !handicap) {
        return "NH";
    } else {
        return handicap.toString();
    }
};


const debugMode = '';//Put 'Mobile' here to test mobile mode, leave blank for desktop
export function detectDeviceType(){

    if(debugMode !== ''){
        return debugMode;
    }
    const ua = navigator.userAgent;

    if (/Mobi|Android/i.test(ua)) {
        return 'Mobile';  // likely a mobile phone
    }

    if (/Tablet|iPad/i.test(ua)) {
        return 'Tablet';  // likely a tablet
    }
      
    return 'Desktop';  // likely a desktop
};

export function detectOrientation(){
    const orientation = window.matchMedia("(orientation: portrait)").matches ? 'portrait' : 'landscape';
    return orientation;
};

export function getBuildType(){
    return packageJson.buildType;
};

export function generateGUID (){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
        const random = (Math.random() * 16) | 0;
        const value = char === 'x' ? random : (random & 0x3) | 0x8;
        return value.toString(16);
    });
};

export function isValidTaskId(taskId){
    if(taskId){
        const regexTaskId = /^\d{4}-\d{5,6}-\d{2}$/;
        if(regexTaskId.test(taskId)){
            return true;
        }
    }
    return false;
}

export function intToUppercaseLetter(num) {
    let result = '';
    while (num >= 0) {
        result = String.fromCharCode((num % 26) + 65) + result;
        num = Math.floor(num / 26) - 1;
    }
    return result;
}

export function isEmailCleanable(email) {
    // Regex to check if the email contains 'corp.' in the subdomain
    const corpDomainRegex = /^([^@]+)@corp\.(.+)$/;
    
    // Test if the email has 'corp.' in the domain part
    return corpDomainRegex.test(email);
}

export function cleanEmail(email) {
    if (isEmailCleanable(email)) {
        // Remove 'corp.' from the domain
        return email.replace('corp.', '');
    }
    return email; // Return the original email if it's not cleanable
}

export function getColorFromGradient(value) {
    value = Math.max(0, Math.min(100, value)); // Clamp value between 0-100

    // Get gradient definition from CSS
    const rootStyles = getComputedStyle(document.documentElement);
    const gradientString = rootStyles.getPropertyValue('--percentage-gradient').trim();

    if (!gradientString.startsWith("linear-gradient")) {
        throw new Error("Invalid gradient format in --percentage-gradient");
    }

    // Extract color stops (e.g., "red 0%", "yellow 50%", "green 100%")
    const stopMatches = gradientString.match(/(\w+\([^)]*\)|#[0-9A-Fa-f]+|\w+)\s*(\d+)%/g);
    if (!stopMatches || stopMatches.length < 2) {
        throw new Error("At least two color stops are required in --percentage-gradient.");
    }

    // Convert stops to { color, position }
    const stops = stopMatches.map(stop => {
        const [, color, position] = stop.match(/(.+?)\s*(\d+)%/) || [];
        return { color: color.trim(), position: parseInt(position, 10) };
    });

    // Convert color to RGB
    function parseColor(color) {
        if (color.startsWith("#")) {
            let hex = color.replace("#", "");
            if (hex.length === 3) hex = hex.split("").map(x => x + x).join(""); // Expand shorthand hex
            return [
                parseInt(hex.substring(0, 2), 16),
                parseInt(hex.substring(2, 4), 16),
                parseInt(hex.substring(4, 6), 16),
            ];
        } else if (color.startsWith("rgb")) {
            return color.match(/\d+/g).map(Number).slice(0, 3);
        } else {
            return [255, 0, 0]; // Default to red if unknown
        }
    }

    const rgbStops = stops.map(stop => ({
        position: stop.position,
        rgb: parseColor(stop.color)
    }));

    // Find the two stops between which 'value' falls
    let start = rgbStops[0], end = rgbStops[rgbStops.length - 1];

    for (let i = 0; i < rgbStops.length - 1; i++) {
        if (value >= rgbStops[i].position && value <= rgbStops[i + 1].position) {
            start = rgbStops[i];
            end = rgbStops[i + 1];
            break;
        }
    }

    // Interpolation ratio between start and end
    const range = end.position - start.position;
    const ratio = range === 0 ? 0 : (value - start.position) / range;

    // Linearly interpolate RGB values
    const r = Math.round(start.rgb[0] * (1 - ratio) + end.rgb[0] * ratio);
    const g = Math.round(start.rgb[1] * (1 - ratio) + end.rgb[1] * ratio);
    const b = Math.round(start.rgb[2] * (1 - ratio) + end.rgb[2] * ratio);

    return `rgb(${r}, ${g}, ${b})`;
}

export function convertAppVersionToReadable(version){
    const parts = version.split('.');
  if (parts.length === 0) return version;

  const firstPart = parts[0];
  if (firstPart.length > 1) {
    const newFirst = firstPart[0];
    const newSecond = firstPart.slice(1);
    return [newFirst, newSecond, ...parts.slice(1)].join('.');
  } else {
    return version;
  }
}

const ROBOT_TEST_FIELD_GROUPS = {
    AttackTarget: ['AttackTarget', 'AttackTolerance'],
    AttackTolerance: ['AttackTarget', 'AttackTolerance'],
    PathTarget: ['PathTarget', 'PathTolerance'],
    PathTolerance: ['PathTarget', 'PathTolerance'],
    FaceToPathTarget: ['FaceToPathTarget', 'FaceToPathTolerance'],
    FaceToPathTolerance: ['FaceToPathTarget', 'FaceToPathTolerance'],
    DynamicLoftTarget: ['DynamicLoftTarget', 'DynamicLoftTolerance'],
    DynamicLoftTolerance: ['DynamicLoftTarget', 'DynamicLoftTolerance'],
    DynamicLieTarget: ['DynamicLieTarget', 'DynamicLieTolerance'],
    DynamicLieTolerance: ['DynamicLieTarget', 'DynamicLieTolerance']
};

export function isValidRobotTestDataField(robotTestData, key) {
    if (!robotTestData || !key) {
        return false;
    }

    const groupedKeys = ROBOT_TEST_FIELD_GROUPS[key];
    if (!groupedKeys) {
        return true;
    }

    return groupedKeys.every((groupKey) => {
        const value = robotTestData[groupKey];
        return value !== undefined && value !== null && value !== INTMIN;
    });
}

let ipPromise;
export async function getPublicIP() {
  if (!ipPromise) {
    ipPromise = fetch('https://api.ipify.org?format=json')
      .then(r => r.json())
      .then(({ ip }) => ip)
      .catch(err => {
        ipPromise = undefined;
        throw err;
      });
  }
  return ipPromise;
}

//SSO Check

